import { UserGroupIcon, CollectionIcon } from "@heroicons/react/solid";

export const ADMIN_NAVIGATON = [
  { name: "User List", icon: UserGroupIcon, href: "/users", current: false },
  { name: "Job List", icon: CollectionIcon, href: "/job-list", current: false },
  // { name: "Tweets List", icon: CollectionIcon, href: "/tweets", current: true },
  { name: "Authors List", icon: CollectionIcon, href: "/authors", current: true },

];
